import { ApolloError, ServerError } from '@apollo/client'
import { Fragment, PropsWithChildren } from 'react'

import { Spinner } from '@/modules/requisitions/components/spinner/Spinner'
import GenericError from '@/modules/shared/components/generic-error/GenericError'
import { useViewType } from '@/modules/shared/hooks/useViewType'
import { classNames } from '@/modules/shared/utils/classNames'

interface QueryResultProps extends PropsWithChildren {
  loading?: boolean
  error?: ApolloError | undefined
  size?: 'md'
  spinnerClassName?: string
  title?: string
}

export function QueryResult({ children, error, loading, size, spinnerClassName, title }: QueryResultProps) {
  const { isUtility } = useViewType()
  const networkError = error?.networkError as ServerError

  if (networkError?.statusCode === 401) {
    return null
  }

  if (error) {
    return (
      <div className={classNames({ 'mt-5 pt-[4.3125rem]': isUtility })}>
        <GenericError />
      </div>
    )
  }

  if (loading) {
    return (
      <div className={classNames('w-full', { 'mt-5 pt-[4.3125rem]': isUtility })}>
        <Spinner
          className={classNames({ 'mt-12 h-28': !size, 'my-5 h-14 md:w-16': size === 'md' }, spinnerClassName)}
        />
        {title && (
          <div className="mt-4 flex justify-center text-gray-500">
            <span>{title}</span>
          </div>
        )}
      </div>
    )
  }

  return <Fragment>{children}</Fragment>
}
